import { onActivated, nextTick } from 'vue'
import { onBeforeRouteLeave } from 'vue-router'

export function useRememberScroll() {
	const rememberScroll = { value: 0 }

	onBeforeRouteLeave(() => {
		rememberScroll.value = document.documentElement.scrollTop
	})

	onActivated(() => {
		// nextTick(() => {
		// 	document.documentElement.scrollTop = rememberScroll.value
		// })
		setTimeout(() => {
			document.documentElement.scrollTop = rememberScroll.value
		})
	})
}

export function useScrollTop() {
	nextTick(() => {
		document.documentElement.scrollTop = 0
	})
}
